import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  type WsOnMessage,
  type WsSliceState,
  wsSlice,
  fillTopic,
} from '@wellesley/ws'
import { userSlice } from '../../slices/userSlice'
import { AccountWithUser } from '@wellesley/openapi'
import { filterValidUsers } from '../../helpers/filterValidUsers/filterValidUsers'
import {
  wsSubscribe,
  wsUnSubscribe,
  updateAccountData,
} from '@wellesley/host-remote/api/actions'

export const useAccountWsUpdate = () => {
  const dispatch = useDispatch()
  const account = useSelector(userSlice.selectors.selectAccount)

  const subscriptionName = fillTopic('account#$account_id', {
    account_id: account?.id || '',
  })

  const accountUpdate = useSelector((state: WsSliceState) =>
    wsSlice.selectors.selectLastUpdateFor(state, {
      subscriptionName,
      mode: 'equals',
    }),
  ) as WsOnMessage<AccountWithUser> | undefined

  useEffect(() => {
    if (!account?.id) return

    dispatch(
      wsSubscribe({
        id: subscriptionName,
        topics: [subscriptionName],
      }),
    )
    return () => {
      dispatch(wsUnSubscribe(subscriptionName))
    }
  }, [account?.id])

  useEffect(() => {
    accountUpdate?.data &&
      dispatch(
        updateAccountData({
          ...accountUpdate.data,
          users: filterValidUsers(accountUpdate.data.users),
        }),
      )
  }, [accountUpdate?.data])
}
